module.exports = __webpack_public_path__ + "static/media/doctor-img3.bd9bafc1.png";